
export const CONTENT_REFERENCE_KEY = 'jacmsContentManager';
export const RESOURCE_REFERENCE_KEY = 'jacmsResourceManager';
export const WIDGET_TYPE_REFERENCE_KEY = 'WidgetTypeManager';
export const USER_REFERENCE_KEY = 'AuthorizationManager';
export const PAGE_REFERENCE_KEY = 'PageManager';
